export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";